import { render, staticRenderFns } from "./Chartpage.vue?vue&type=template&id=23787efe&scoped=true"
import script from "./Chartpage.vue?vue&type=script&lang=js"
export * from "./Chartpage.vue?vue&type=script&lang=js"
import style0 from "./Chartpage.vue?vue&type=style&index=0&id=23787efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23787efe",
  null
  
)

export default component.exports